module.exports = __webpack_public_path__ + "img/client-riza.ffca4ffe.png";